import styled, { css } from 'styled-components'

import LoginForm from '../../forms/LoginForm'
import ActionButton from '../ActionButton'

export const Block = styled.div`
  background-color: ${({ theme }) => theme.colors.brownBack};
  padding: 3rem;
`

export const Form = styled(LoginForm)``

export const Wrapper = styled.div`
  ${({ theme }) => theme.breakpoints.up('tablet')} {
    display: flex;
  }
`

export const Left = styled.div`
  flex: 1;

  ${({ theme }) => theme.breakpoints.down('tablet')} {
    padding-bottom: 4rem;
    border-bottom: 2px dashed ${({ theme }) => theme.colors.greyContour};
  }

  ${({ theme }) => theme.breakpoints.up('tablet')} {
    padding-right: 3rem;
  }

  ${({ theme }) => theme.breakpoints.up('desktop')} {
    padding-right: 6rem;
  }
`

export const Inner = styled.div``

export const Right = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 2rem;

  ${({ theme }) => theme.breakpoints.down('tablet')} {
    padding-top: 4rem;
  }

  ${({ theme }) => theme.breakpoints.up('tablet')} {
    border-left: 2px dashed ${({ theme }) => theme.colors.greyContour};
    padding-left: 3rem;
  }

  ${({ theme }) => theme.breakpoints.up('desktop')} {
    padding-left: 6rem;
  }
`

export const Button = styled(ActionButton)`
  align-self: flex-end;
`

export const Title = styled.h3<{ $centered?: boolean }>`
  ${({ theme }) => theme.textStyles.firaSans2XlBold};
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin-bottom: 4rem;
  margin-top: 0;

  ${({ $centered }) =>
    $centered &&
    css`
      text-align: center;
    `};
`

export const Description = styled.p`
  ${({ theme }) => theme.textStyles.firaSansLg};
  color: ${({ theme }) => theme.colors.bluePrimary};
`
